export default __webpack_public_path__ + "8963b788c991c338a091f6eff927c538.png";